import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {Body, H1, H3} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import authentication from "@irati/auth"

import {LinearGradiantCard, NumberOfRedemptions} from "./styled"
import {DealVariant, DEAL_VARIANTS_UK} from "./Variants"

interface DealData {
  dealId: string
  savings: number
  redemptions: number
}

interface Props {
  deals?: DealData[]
  redemptions: number
  unique: number
  savings: number
}

const Redemptions: FC<Props> = ({deals, unique, redemptions, savings}) => {
  const businessName = authentication.business().businessName
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <Flex gap={1}>
      {deals?.map((deal, i) => {
        const variant = DEAL_VARIANTS_UK.find((d) => d.dealId === deal.dealId) as DealVariant
        const {dealTitle, dealText, dealName} = variant
        return (
          variant && (
            <LinearGradiantCard marginBottom c1={theme.colors.primary1} c2={theme.colors.success} key={`yourPerkboxStoryRedemption-${i}`}>
              <Flex alignItems="center" direction="column" gap={1}>
                <NumberOfRedemptions justifyContent="center" alignItems="center">
                  {variant.dealImg && <img src={formatMessage({id: variant.dealImg})} height={100} width={100} />}
                </NumberOfRedemptions>
                <H3 color={theme.colors.greys.white}>
                  <FormattedMessage id={dealTitle} />
                </H3>
                <Body small maxWidth="100%" color={theme.colors.greys.white}>
                  <FormattedMessage
                    id={dealText}
                    values={{
                      businessName: (
                        <Body small display="inline" color={theme.colors.greys.white}>
                          <FormattedMessage id={businessName} />
                        </Body>
                      ),
                      dealName: (
                        <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                          <FormattedMessage id={dealName} />
                        </Body>
                      ),
                      redemptions: (
                        <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                          {deal.redemptions}
                        </Body>
                      ),
                      savings: (
                        <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                          {formatCurrency({value: deal.savings})}
                        </Body>
                      )
                    }}
                  />
                </Body>
              </Flex>
            </LinearGradiantCard>
          )
        )
      })}
      <LinearGradiantCard marginBottom c1={theme.colors.primary1} c2={theme.colors.success}>
        <Flex alignItems="center" direction="column" gap={1}>
          <NumberOfRedemptions justifyContent="center" alignItems="center">
            <H1 color={theme.colors.greys.white}>{redemptions}</H1>
          </NumberOfRedemptions>
          <H3 color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.yourPerkboxStory.numberOfRedemptions.title" />
          </H3>
          <Body small maxWidth="100%" color={theme.colors.greys.white}>
            <FormattedMessage
              id="admin.components.yourPerkboxStory.numberOfRedemptions.body"
              values={{
                businessName: (
                  <Body small display="inline" color={theme.colors.greys.white}>
                    <FormattedMessage id={businessName} />
                  </Body>
                ),
                unique: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    <FormattedMessage id="admin.components.yourPerkboxStory.numberOfRedemptions.unique" values={{unique}} />
                  </Body>
                ),
                redemptions: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    {redemptions}
                  </Body>
                ),
                savings: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    {formatCurrency({value: savings})}
                  </Body>
                )
              }}
            />
          </Body>
        </Flex>
      </LinearGradiantCard>
    </Flex>
  )
}

export default Redemptions
